export abstract class Feature {
  isEnabled = false;
}
